module.exports = __webpack_public_path__ + "static/media/landTransport.ca3dba0b.jpeg";